// @flow

/**
 @deprecated It will be removed in 6 months 09-15-2025. Not used anymore, remove in the future
 */
export const CLASS_INSERT_BUTTON = {
    MAIN: 'insert_column_button',
    BUTTON: 'insert_column_button__button',
    ICON: 'insert_column_button__icon'
};
